import React from "react";
import { Box, Typography, styled } from "@mui/material";

const StyledPrimaryGoalBox = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "90%",
  margin: theme.spacing(4, "auto", 7),
  padding: 0,
  maxWidth: "800px",
  borderRadius: theme.spacing(2.5),
  border: `1.5px solid ${theme.palette.primary.main}`,
  boxShadow: `-8px 8px 0px ${theme.palette.primary.light}`,
  overflow: "hidden",
  backgroundColor: "white",
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
}));

export const PrimaryGoalResults = ({ studyData }) => {

  return (
    <StyledPrimaryGoalBox data-model-id="180:1916">
      {/* Header */}
      <Box
        sx={{
          height: 66,
          width: "100%",
          bgcolor: "#062059",
   
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 900,
            color: "white",
            textAlign: "center",
            fontSize: "1.25rem",
            width: "100%",
			 lineHeight:"1.6",
				 marginBottom:"0"
				
          }}
        >
          Primary goal results (ORR)
        </Typography>
      </Box>

      {/* Desktop Layout */}
      <Box sx={{ display: { xs: 'none', md: 'block' }, position: "relative", width: "100%", height: 189 }}>
          <Box sx={{ width: "100%", height: 45, bgcolor: "#0620591a", display: "flex" }}>
            {studyData.map((study) => (
              <Typography
                key={study.id}
                sx={{
                  width: "50%",
                  fontWeight: 900,
                  fontSize: "1.125rem",
                  color: "#062059",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
				  marginBottom: "0"
                }}
              >
                {study.title}
              </Typography>
            ))}
          </Box>

          {/* Vertical Divider */}
          <Box
            sx={{
              position: "absolute",
              width: "1px",
              height: 189,
              top: 0,
              left: "50%",
              transform: "translateX(-0.5px)",
              bgcolor: "#062059",
			  marginBottom: "0"
            }}
          />

          {studyData.map((study, index) => (
            <Box
              key={study.id}
              sx={{
                position: "absolute",
                width: "50%",
                height: 139,
                top: 44,
                left: index === 0 ? 0 : "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
				marginBottom: "0",  marginTop:"0" 	
              }}
            >
              <Box sx={{ width: "90%", textAlign: "center",}}>
                <Typography sx={{ fontWeight: 900, fontSize: "1.875rem", color: "#b85967", marginBottom: "0", lineHeight: "1" }}>
                  {study.percentage}
                </Typography>
                <Typography
				  sx={{ fontWeight: 900, fontSize: "1.125rem", color: "#b85967", marginBottom: "0" }}
				  dangerouslySetInnerHTML={{ __html: study.description }}
				/>
                <Typography sx={{ fontWeight: 400, fontSize: "1.125rem", color: "black", marginBottom: "0" }}>
                  {study.details}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

      {/* Mobile Layout */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <>
          {studyData.map((study, index) => (
            <React.Fragment key={study.id}>
              {index === 1 && (
                <Box
                  sx={{
                    width: "100%",
                    height: "1px",
                    bgcolor: "#062059",
                    mt: 0,
						
                  }}
                />
              )}
              <Box
                sx={{
                  height: 51,
                  width: "100%",
                  bgcolor: "#0620591a",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: index === 0 ? 0 : 0,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 900,
                    fontSize: "1.125rem",
                    color: "#062059",
                    textAlign: "center",
						marginBottom: "0"
                  }}
                >
                  {study.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography sx={{ fontWeight: 900, fontSize: "1.875rem", color: "#b85967", marginBottom: "0" }}>
                    {study.percentage}
                  </Typography>
                  <Typography
					  sx={{ fontWeight: 900, fontSize: "1.125rem", color: "#b85967", marginBottom: "0" }}
					  dangerouslySetInnerHTML={{ __html: study.description }}
					/>
                  <Typography sx={{ fontWeight: 400, fontSize: "1.125rem", color: "black", marginBottom: "0" }}>
                    {study.details}
                  </Typography>
                </Box>
              </Box>
            </React.Fragment>
          ))}
        </>
      </Box>
    </StyledPrimaryGoalBox>
  );
};
